import type { FontFamily, Nullish } from '@iheartjane/types';
import uniq from 'lodash-es/uniq';

/** @see https://developer.mozilla.org/en-US/docs/Web/HTML/Reference/Attributes/rel#stylesheet */
export const fontCssTags = (
  fonts?: Nullish<{
    body?: Nullish<FontFamily>;
    heading?: Nullish<FontFamily>;
  }>
) => {
  const fontsSrc = {
    bodyFontStyleSheet: fonts?.body?.url,
    headingFontStyleSheet: fonts?.heading?.url,
  };

  return uniq(Object.values(fontsSrc))
    .filter(Boolean)
    .map((stylesheetUrl) => ({
      crossOrigin: 'anonymous',
      href: stylesheetUrl,
      rel: 'stylesheet',
      tagName: 'link',
    }));
};
